import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';
import { faClock } from '@rtkwlf/pro-solid-svg-icons/faClock';

export const timePickerTheme: Pick<Components<Theme>, 'MuiTimePicker'> = {
  MuiTimePicker: {
    defaultProps: {
      slots: {
        openPickerIcon: () => <FontAwesomeIcon icon={faClock} size="xs" />,
      },
    },
  },
};
